import { render, staticRenderFns } from "./portalInfoConfig.vue?vue&type=template&id=4007c9d0&"
import script from "./portalInfoConfig.vue?vue&type=script&lang=js&"
export * from "./portalInfoConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports